export const taskIntro = `
An AI dress designer will be your creative partner in crafting unique dresses, like the examples shown below.
Starting from an original dress, the AI will imagine a range of enhanced designs. Your role is to guide its
creativity by using a slider to rate how good each enhanced design is compared to the original, helping the AI
refine its ideas step by step.`;

export const taskSteps = [
  "Look at the original and the enhanced dress side by side.",
  "Use the slider to rate how well the enhanced design matches or improves on the original.",
  "The AI will take your feedback, adjust the design, and present you with a new version.",
  "Watch the dress evolve through several iterations until it meets your vision.",
  "When you are happy with the result, click “I’m satisfied” to finish that dress."
];

export const tutorialText = [
  `This is the tutorial mode of our study. In the tutorial mode buttons are static and it's just a visual explaination.
        Please read everything carefully and click the done button when you finished.
        Our AI-dress designer will help you to find dresses like the ones below and freely design dresses. For this the AI-dress designer will propose
        a range of dresses. Please provide feedback about AI-designed dresses using a slider to tell how good the new designed dresses is, compared to the target dress.
        The AI running in the background will improve the new designed dresses iteratively according to your preference. During the study you can click the
        "I'm satisfied" button to terminate if you think the new designed dress is similar to the target dress.`
];
export const welcomeText = [
  `Welcome to AI-Dress Designer Couture Rêvée: Our personalized Fashion AI system learns from your feedback and generates new images that iteratively come closer and closer to a specific target
  fashion item – regardless of whether we give you a target image of a fashion item or you have a specific design in mind.
  We are investigating how quickly we can find a desired design and how similar it actually is to the target.
  How good can we predict & generate given - and mental images of fashion pieces iteratively? You will help us to find out by exploring the design space with our AI.
  
  Thank you for taking part in our study!`
];

export const buttonStartText = "Start";

export const textTargetDress = "Target Dress";
export const textNewDress = "New Designed Dress";

export const confirmSatisfiedQuesion = "Are you sure you are satisfied with the current results?";
export const confirmSatisfiedButtonCancel = "Cancel";
export const confirmSatisfiedButtonConfirm = "Confirm";

export const textTaskStatementTarget = "The new designed dress is exactly the same as the target dress.";
export const textTaskStatementFree = "The dress is exactly the same than the imagined dress described in text form.";


export const textRatingAgree = "Strongly Agree"
export const textRatingDisagree = "Strongly Disagree";
export const buttonSubmitFeedback = "Submit Feedback";
export const buttonConfirmSatisfied = "I am Satisfied";

export const pleaseRateImage = "Rate the similarity of the new designed dress to the target dress";
